'use strict';

import { createContext } from '@lit/context';

export const storeContext = createContext('pandemonium-store');
